exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".line-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.circle {\n  width: 20px;\n  height: 20px;\n  border: 4px solid var(--primary-color);\n  border-radius: 50%;\n  background-color: transparent; }\n\n.line {\n  height: 4px;\n  background-color: var(--primary-color);\n  width: 100px; }\n", ""]);

// exports
